import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

const initDatadog = () => {
  if (process.env.REACT_APP_DD_ENV
    && process.env.REACT_APP_DD_APP_ID
    && process.env.REACT_APP_DD_CLIENT_TOKEN)
  {
    datadogRum.init({
      applicationId: process.env.REACT_APP_DD_APP_ID || '',
      clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN || '',
      site: 'us3.datadoghq.com',//process.env.REACT_DD_SITE || 'us3.datadoghq.com',
      service: 'argoli-web',
      env: process.env.REACT_APP_DD_ENV,
      version: process.env.REACT_APP_BUILD_ID,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogLogs.init({
      clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN || '',
      site: 'us3.datadoghq.com',//process.env.REACT_DD_SITE || 'us3.datadoghq.com',
      sessionSampleRate: 100,
      forwardConsoleLogs: 'all',
    })
  }
}

export default initDatadog;

